$(document).ready(function () {
    $('.event-action-date, #sls-initial-text .pd-button').click(function () {
        $('.event-action-button').click();
    });
});
